export const ADMIN = 'admin';
export const EDITOR = 'editor';
// export const DOCTOR = 'doctor';
